import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';

import {
  CentralEmailResponse,
  DeleteCentralEmailRespone,
  NotificationRecipient,
  NotificationRecipientsResponse,
  Notifications,
  UpdateMailSubscriptionResponse,
} from './notifications.model';

@Injectable()
export class NotificationsApi {
  private readonly mailsEndPointPrefix = 'iot/v1/mails/subscriptions';
  constructor(private clientService: ClientService) {}

  getMailSubscription(): Observable<Notifications> {
    const endpoint = this.mailsEndPointPrefix;

    return this.clientService.get(endpoint);
  }

  updateMailSubscription(isActive: boolean): Observable<any> {
    const endpoint = this.mailsEndPointPrefix;

    return this.clientService.put(endpoint, { isActive });
  }

  getNotificationRecipients(
    companyNumber: string,
    cursor?: string
  ): Observable<NotificationRecipientsResponse> {
    let endpoint = `iot/v1/mails/subscriptions/${companyNumber}`;

    if (cursor) {
      endpoint = `${endpoint}?cursor=${cursor}`;
    }

    return this.clientService.get(endpoint);
  }

  updateNotificationRecipient(
    companyNumber: string,
    isActive: boolean,
    recipient: NotificationRecipient
  ): Observable<UpdateMailSubscriptionResponse> {
    const endpoint = `iot/v1/mails/subscriptions/${companyNumber}`;
    const body = {
      companyNumber,
      viAccount: recipient.viAccount,
      isActive,
    };

    return this.clientService.put(endpoint, body);
  }

  getCentralEmail(companyNumber: string): Observable<CentralEmailResponse> {
    const endpoint = `iot/v1/mails/inbox/${companyNumber}`;

    return this.clientService.get(endpoint);
  }

  setCentralEmail(companyNumber: string, email: string): Observable<CentralEmailResponse> {
    const endpoint = `iot/v1/mails/inbox/${companyNumber}`;
    const body = {
      email,
    };

    return this.clientService.post(endpoint, body);
  }

  updateCentralEmail(companyNumber: string, email: string): Observable<CentralEmailResponse> {
    const endpoint = `iot/v1/mails/inbox/${companyNumber}`;
    const body = {
      email,
    };

    return this.clientService.put(endpoint, body);
  }

  deleteCentralEmail(companyNumber): Observable<DeleteCentralEmailRespone> {
    const endpoint = `iot/v1/mails/inbox/${companyNumber}`;

    return this.clientService.delete(endpoint);
  }
}
